/***
*
*   RECENT ACTIVITY
*   Shows latest signups, plan changes, and suspensions
*
**********/

import { Card, Badge, Icon } from 'components/lib';
import Style from './dashboard.tailwind.js';

export function RecentActivity(props) {
  const { data = [], loading } = props;

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
      month: 'short', 
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getActivityIcon = (type) => {
    switch (type) {
      case 'signup': return 'user-plus';
      case 'plan_change': return 'refresh-cw';
      case 'suspension': return 'alert-circle';
      default: return 'activity';
    }
  };

  const getActivityColor = (type) => {
    switch (type) {
      case 'signup': return 'green';
      case 'plan_change': return 'blue';
      case 'suspension': return 'red';
      default: return 'gray';
    }
  };

  const getActivityLabel = (activity) => {
    switch (activity.activity_type) {
      case 'signup':
        return <span><strong>{activity.name}</strong> signed up</span>;
      case 'plan_change':
        return (
          <span>
            <strong>{activity.name}</strong> changed plan
          </span>
        );
      case 'suspension':
        return <span><strong>{activity.name}</strong> was suspended</span>;
      default:
        return <span><strong>{activity.name}</strong> - {activity.activity_type}</span>;
    }
  };

  return (
    <Card title="Recent Activity" loading={loading}>
      <div className={Style.activityList}>
        {data.length > 0 ? (
          data.map((activity, index) => (
            <div key={activity.id || index} className={Style.activityItem}>
              <div className={Style.activityIcon}>
                <Icon 
                  image={getActivityIcon(activity.activity_type)} 
                  color={getActivityColor(activity.activity_type)}
                  size={16}
                />
              </div>
              <div className={Style.activityContent}>
                <div className={Style.activityTitle}>
                  {getActivityLabel(activity)}
                </div>
                <div className={Style.activityMeta}>
                  <Badge 
                    text={activity.plan} 
                    color={activity.active ? 'green' : 'red'} 
                  />
                  <span className={Style.activityDate}>
                    {formatDate(activity.date)}
                  </span>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className={Style.noData}>No recent activity</div>
        )}
      </div>
    </Card>
  );
}